import { createSlice } from '@reduxjs/toolkit'

export const languageReducer = createSlice({
  name: 'language',
  initialState: {
    value: 'en',
  },
  reducers: {
    setLanguage:(state, action)=>{
        state.value = action.payload
    },
  },
})

export const contactusPopupReducer = createSlice({
  name: 'contactusPopup',
  initialState: {
    value: false,
  },
  reducers: {
    setContactusPopup:(state, action)=>{
        state.value = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setLanguage } = languageReducer.actions
export const { setContactusPopup } = contactusPopupReducer.actions

